module.exports = __webpack_public_path__ + "img/19.7b23bb98.jpg";